
import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const StickyNotification = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:right-6 z-50 animate-slide-up">
      <div className="bg-gradient-to-r from-blue-primary to-orange-accent text-white rounded-lg p-3 shadow-lg border border-white/20 max-w-sm mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
              <span className="text-xs font-medium">Limited Time</span>
            </div>
            <p className="text-sm font-medium">
              Join the Waitlist Before Launch
            </p>
          </div>
          
          <div className="flex items-center gap-2">
            <Button
              size="sm"
              variant="outline"
              className="bg-white text-blue-primary hover:bg-gray-50 border-white text-xs px-3 py-1 h-7"
            >
              Join Now
            </Button>
            <button
              onClick={() => setIsVisible(false)}
              className="text-white/70 hover:text-white p-1"
            >
              <X className="w-3 h-3" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StickyNotification;
